import SegmentBuilderCondition from "../SegmentBuilderCondition";
import SegmentBuilderConditionsAndBlock from "../SegmentBuilderConditionsAndBlock";
import { useTagAndSegment } from "../../contexts/tagAndSegment";

const SegmentBuilderConditions = () => {
  const { segmentConditions, handleAddOr } = useTagAndSegment();

  return (
    <div className="flex flex-col items-start mb-4">
      <h2 className="text-md">
        Segment Filters
      </h2>
      {/* If it's a single condition (no .type) */}
      {!segmentConditions.type && (
        <SegmentBuilderConditionsAndBlock node={segmentConditions}>
          <SegmentBuilderCondition condition={segmentConditions} />
        </SegmentBuilderConditionsAndBlock>
      )}

      {/* If top level is an AND group */}
      {segmentConditions.type === "AND" && (
        <SegmentBuilderConditionsAndBlock
          key={segmentConditions.id}
          node={segmentConditions}
        >
          {segmentConditions.conditions?.map((child, index) => (
            <div key={`${child.id}-wrapper`} className="flex flex-col items-start w-full">
              <SegmentBuilderCondition key={child.id} condition={child} />
              {index < segmentConditions.conditions.length - 1 && (
                <div className="text-gray-600 my-1 bg-gray-100 rounded-2xl px-2 py-1 self-start">And</div>
              )}
            </div>
          ))}
        </SegmentBuilderConditionsAndBlock>
      )}

      {/* If top level is an OR group (segmentConditions.type === "OR") */}
      {segmentConditions.type === "OR" &&
        segmentConditions.conditions?.map((node, index) => (
          <div key={`${node.id}-wrapper`} className="flex flex-col items-start w-full">
            {!node.type ? (
              <SegmentBuilderConditionsAndBlock key={node.id} node={node}>
                <SegmentBuilderCondition condition={node} />
              </SegmentBuilderConditionsAndBlock>
            ) : (
              <SegmentBuilderConditionsAndBlock key={node.id} node={node}>
                {node.conditions?.map((child, index) => (
                  <div key={`${child.id}-wrapper`} className="flex flex-col items-start w-full">
                    <SegmentBuilderCondition key={child.id} condition={child} />
                    {index < node.conditions.length - 1 && (
                      <div className="text-gray-600 my-1 bg-gray-100 rounded-2xl px-2 py-1 self-start">And</div>
                    )}
                  </div>
                ))}
              </SegmentBuilderConditionsAndBlock>
            )}
            {index < segmentConditions.conditions.length - 1 && (
              <div className="text-gray-600 my-1 bg-gray-100 rounded-2xl px-2 py-1 self-start">Or</div>
            )}
          </div>
        ))}

      <button onClick={handleAddOr} className="text-blue-500 border border-blue-500 rounded-xl px-7 py-4 my-1">
        + Add "or"
      </button>
    </div>
  );
};

export default SegmentBuilderConditions;
